export enum TimeLocale {
  EnUs = 'en-US',
  EnGb = 'en-GB',
}
export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const MONTH_YEAR_DATE_FORMAT = 'MMMM yyyy';
export const MONTH_SHORT_DATE_FORMAT = 'MMM';
export const YEAR_MONTH_DATE_FORMAT = 'yyyy-MM';
export const ISO_DATE_FORMAT = 'yyyy-MM-dd';

export interface DateFormatOptions {
  defaultDateFormat: string;
  defaultDateTimeFormat: string;
  defaultTimeFormat: string;
}

export const dateFormats: Record<TimeLocale, DateFormatOptions> = {
  [TimeLocale.EnUs]: {
    defaultDateFormat: DEFAULT_DATE_FORMAT,
    defaultDateTimeFormat: 'MM/dd/yyyy h:mm a',
    defaultTimeFormat: 'h:mm a',
  },
  // Mostly for testing purpose, but might be useful in the future
  [TimeLocale.EnGb]: {
    defaultDateFormat: 'dd/MM/yyyy',
    defaultDateTimeFormat: 'dd/MM/yyyy HH:mm',
    defaultTimeFormat: 'HH:mm',
  },
};
